import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllAdvertiserPics.graphql';
import { Query, QueryallAdvertiserPicsArgs } from '../../__generated__/globalTypes';

export const useAllAdvertiserPicsQuery = (options?: QueryHookOptions<Query, QueryallAdvertiserPicsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallAdvertiserPicsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllAdvertiserPicsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallAdvertiserPicsArgs>
): QueryResult<Query, QueryallAdvertiserPicsArgs> & {
  getAllAdvertiserPics: LazyQueryExecFunction<Query, QueryallAdvertiserPicsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllAdvertiserPics, result] = useLazyQuery<Query, QueryallAdvertiserPicsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllAdvertiserPics, ...result };
};

export const useAllAdvertiserPicsPromiseQuery = () => {
  const client = useApolloClient();

  const getAllAdvertiserPics = useCallback(
    (options?: Omit<QueryOptions<QueryallAdvertiserPicsArgs, Query>, 'query'>) =>
      client.query<Query, QueryallAdvertiserPicsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllAdvertiserPics };
};
// Suspense Query Hooks
export const useAllAdvertiserPicsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallAdvertiserPicsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallAdvertiserPicsArgs>(QUERY, {
    ...options
  });

  return result;
};
